import React from 'react';

// material ui
import { Button, DialogTitle, Dialog, DialogContent, DialogActions, DialogContentText } from '@mui/material';

// i18n
// import { useTranslation } from 'react-i18next';

// React Crop
import 'react-image-crop/dist/ReactCrop.css';

// proptypes
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ImageDeleteDialog = ({ open, handleDeleteAvatarDialogClose, handleDeleteAvatar }) => {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleDeleteAvatarDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{t('DeleteImage')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{t('SureDeleteMessage')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => handleDeleteAvatar(e)} color="primary">
                        {t('Delete')}
                    </Button>
                    <Button onClick={handleDeleteAvatarDialogClose} color="primary">
                        {t('Cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

ImageDeleteDialog.propTypes = {
    open: propTypes.bool,
    handleDeleteAvatarDialogClose: propTypes.func,
    handleDeleteAvatar: propTypes.func
};

export default ImageDeleteDialog;
